import { bundleModule } from '@/store/bundle/module'
import { examModule } from '@/store/exam/module'
import { groupModule } from '@/store/group/module'
import { instructorModule } from '@/store/instructor/module'
import { licenseModule } from '@/store/license/module'
import { organizationModule } from '@/store/organization/module'
import { statsModule } from '@/store/stats/module'
import { studentModule } from '@/store/student/module'
import { userModule } from '@/store/user/module'
import { getInitialAssignmentState } from '@/store/assignment/state'
import { getInitialBundleState } from '@/store/bundle/state'
import { getInitialExamState } from '@/store/exam/state'
import { getInitialGroupState } from '@/store/group/state'
import { getInitialInstructorState } from '@/store/instructor/state'
import { getInitialLicenseState } from '@/store/license/state'
import { getInitialOrganizationState } from '@/store/organization/state'
import { getInitialStatsState } from '@/store/stats/state'
import { getInitialStudentState } from '@/store/student/state'
import { getInitialUserState } from '@/store/user/state'
import { analyticsModule } from '@/store/analytics/module'
import { getInitialAnalyticsState } from '@/store/analytics/state'
import { stripeModule } from '@/store/stripe/module'
import { getInitialStripeState } from '@/store/stripe/state'
import { getInitialIntegrationsState } from '@/store/integrations/state'
import { integrationsModule } from '@/store/integrations/module'
import { assignmentModule } from '@/store/assignment/module'
import { tableModule } from '@/store/table/module'
import { getInitialTablesState } from '@/store/table/state'

const mapStateProperties = <ModuleState>(
    moduleState: ModuleState,
    newState: ModuleState
) => {
    for (const stateKey in newState) {
        moduleState[stateKey] = newState[stateKey]
    }
}

export const resetState = () => {
    mapStateProperties(analyticsModule.state, getInitialAnalyticsState())
    mapStateProperties(bundleModule.state, getInitialBundleState())
    mapStateProperties(examModule.state, getInitialExamState())
    mapStateProperties(groupModule.state, getInitialGroupState())
    mapStateProperties(instructorModule.state, getInitialInstructorState())
    mapStateProperties(licenseModule.state, getInitialLicenseState())
    mapStateProperties(organizationModule.state, getInitialOrganizationState())
    mapStateProperties(statsModule.state, getInitialStatsState())
    mapStateProperties(stripeModule.state, getInitialStripeState())
    mapStateProperties(studentModule.state, getInitialStudentState())
    mapStateProperties(userModule.state, getInitialUserState())
    mapStateProperties(integrationsModule.state, getInitialIntegrationsState())
    mapStateProperties(assignmentModule.state, getInitialAssignmentState())
    mapStateProperties(tableModule.state, getInitialTablesState())
}
